module.exports = __webpack_public_path__ + "static/media/arts.8e57e0dd.jpg";